<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.80985 12.9501C4.94231 12.9501 4.14132 13.2419 3.49996 13.7325V12.68C3.45996 10.36 4.30996 8.19005 5.90996 6.56005C7.49996 4.94005 9.63996 4.05005 11.95 4.05005C16.67 4.05005 20.5 7.89005 20.5 12.6V13.7327C19.8586 13.242 19.0575 12.9501 18.1899 12.9501H18.0599C15.9599 12.9501 14.2499 14.6601 14.2499 16.7601V18.6401C14.2499 20.7401 15.9599 22.4501 18.0599 22.4501H18.1899C20.2899 22.4501 21.9999 20.7401 21.9999 18.6401V18.3099C21.9999 18.3066 22 18.3033 22 18.3V12.6C22 7.06005 17.49 2.55005 11.95 2.55005C9.23996 2.55005 6.71996 3.60005 4.83996 5.51005C2.95996 7.43005 1.94996 9.99005 1.99996 12.7V16.7308L1.99985 16.7601V18.6401C1.99985 20.7401 3.70985 22.4501 5.80985 22.4501H5.93985C8.03985 22.4501 9.74985 20.7401 9.74985 18.6401V16.7601C9.74985 14.6601 8.03985 12.9501 5.93985 12.9501H5.80985Z"
      fill="#0FA2B7"
    />
  </svg>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
